import { useEffect, useRef } from "react";
import { useImmer } from "use-immer";

import { IgTypography } from "@intelligems/ig-theme";
import Stack from "@mui/material/Stack";
import { loadProducts } from "@src/store/slices/productPicker/util/loadProducts";

// The list of selected products, shown below a condition when expanded. THEN
// already knows its titles; conditions store ids only, so we look those up.
export const SelectedProductNames = ({
  productIds,
  knownTitles,
}: {
  productIds: string[];
  knownTitles?: Record<string, string>;
}) => {
  const [resolved, setResolved] = useImmer<Record<string, string>>({});
  const mounted = useRef(true);
  useEffect(() => () => void (mounted.current = false), []);

  useEffect(() => {
    const missing = productIds.filter(
      (id) => !knownTitles?.[id] && !resolved[id]
    );
    if (missing.length === 0) {
      return;
    }
    void loadProducts({
      first: missing.length,
      query: missing.map((id) => `id:${id}`).join(" OR "),
    }).then((res) => {
      if (!mounted.current) {
        return;
      }
      setResolved((draft) => {
        for (const product of res.data) {
          draft[product.id] = product.title;
        }
      });
    });
  }, [productIds, knownTitles, resolved, setResolved]);

  return (
    <Stack spacing={0.5} sx={{ pl: 1 }}>
      {productIds.map((id) => (
        <IgTypography key={id} variant="body2" color="textSecondary">
          {knownTitles?.[id] ?? resolved[id] ?? id}
        </IgTypography>
      ))}
    </Stack>
  );
};
